import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../components/Button'
import Icon from '../../components/Icon'
import Private from '../../components/Private'
import Text from '../../components/Text'
import routes from '../../config/routes'
import Disable from './Account/Disable'
import { Container } from './styles'
import Axios from 'axios'
import { useAuth } from '@polvo-labs/react-auth'

interface Props {

}

const SettingsMenuScreen: React.FC<Props> = () => {
  const history = useHistory()
  const { token } = useAuth()

  return (
    <Private>
      <Text
        style={{ marginBottom: '22px' }}
        tag="h1"
      >
        <Button
          style={{paddingLeft:'0px'}}
          label={(
            <Icon
              name="close"
            />
          )}
          small
          backgroundColor="transparent"
          onClick={() => history.push(routes.settings.index.path)}
        />
        {' '}
        Privacidade e segurança
      </Text>
      <Container>
        <div
          style={{ marginTop: '14px' }}
          onClick={() => {
            Axios({
              method: 'GET',
              url: `${process.env.REACT_APP_API_URL}/users/report/token`,
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }).then(({ data }) => {
              console.log(data.token)
              const url = process.env.REACT_APP_API_URL + '/users/report/pdf/' + data.token
              window.location.href=url
            })

            // history.push(routes.settings.security.index.path)
          }}
        >
          <Button
            style={{ float: 'left', paddingLeft: '0px' }}
            before={(
              <svg
                width="16"
                height="20"
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 1V15M8 15L5 12M8 15L11 12M1 19H15"
                  stroke="#868686"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>


            )}
            label="Download de dados"
            backgroundColor="transparent"
            fontColor="darkGray"
          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon

                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />

        </div>
        <div
          style={{ marginTop: '14px' }}
          onClick={() => history.push(routes.settings.security.index.path)}
        >
          <Button
            style={{ float: 'left', paddingLeft: '0px' }}
            before={(
              // <Icon
              //   name="security-color"
              // />
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 12V14M5 8V4C5 2.34315 6.34315 1 8 1H10C11.6569 1 13 2.34315 13 4V8M3 18H15C16.1046 18 17 17.1046 17 16V10C17 8.89543 16.1046 8 15 8H3C1.89543 8 1 8.89543 1 10V16C1 17.1046 1.89543 18 3 18Z"
                  stroke="#868686"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

            )}
            label="Alterar senha"
            backgroundColor="transparent"
            fontColor="darkGray"
          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon

                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />

        </div>
        <div
          style={{ marginTop: '14px' }}
          onClick={() => history.push(routes.privacy.path)}
        >
          <Button
            style={{ float: 'left', paddingLeft: '0px' }}
            before={(
              // <Icon
              //   name="security-color"
              // />
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 5H10.009M10 15V9H9M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
                  stroke="#868686"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

            )}
            label="Políticas de privacidade"
            backgroundColor="transparent"
            fontColor="darkGray"
          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon

                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />

        </div>
        <div
          style={{ marginTop: '14px' }}
          onClick={() => history.push(routes.terms.path)}
        >
          <Button
            style={{ float: 'left', paddingLeft: '0px' }}
            before={(
              // <Icon
              //   name="security-color"
              // />
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 5H10.009M10 15V9H9M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
                  stroke="#868686"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

            )}
            label="Termos de uso"
            backgroundColor="transparent"
            fontColor="darkGray"
          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon

                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />

        </div>

        <Disable />


      </Container>
    </Private>
  )
}

export default SettingsMenuScreen
